
import { Component, Vue } from 'vue-property-decorator'
import TixStepper from '@/components/forms/TixStepper.vue'
import FormInput2 from "@/components/forms/FormInput2.vue";

@Component({ name: 'ElementsStory', components: { FormInput2, TixStepper } })
export default class extends Vue {
  testMessage: string = 'Test message, <a href="">test link</a>.'
}
